import { Alert, AlertDescription, AlertTitle } from '@/shared/ui/shadcn/alert';
import { Button } from '@/shared/ui/shadcn/button';

interface InviteFailedStepProps {
  message: string;
  onRetry: () => void;
}

export function InviteFailedStep({ message, onRetry }: InviteFailedStepProps) {
  return (
    <div className="w-full">
      <Alert variant="destructive">
        <AlertTitle>Invite link failed</AlertTitle>
        <AlertDescription>
          <div className="flex flex-col gap-2">
            <p>{message}</p>
            <p className="text-muted-foreground text-xs">
              If this link was shared with you, ask your administrator to generate a new one.
            </p>
            <div>
              <Button type="button" variant="secondary" onClick={onRetry}>
                Refresh
              </Button>
            </div>
          </div>
        </AlertDescription>
      </Alert>
    </div>
  );
}
